export default [
  { title: "Bekaert Global", url: "https://www.bekaert.com/" },
  { title: "Bekaert Chinese", url: "https://www.bekaert.cn/" },
];
